'use client';

import dynamic from 'next/dynamic';

//* Styles
import NetworkOfRepresentativesTemplateStyle from './style';

//* Components
const GlobalHeroSection = dynamic(() => import('@/sections/GlobalHeroSection'), {
	ssr: true,
});
const PointsSection = dynamic(() => import('../components/PointsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const MapFilterSection = dynamic(() => import('../components/MapFilterSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const NetworkOfRepresentativesTemplate = ({ pageData, representatives }) => {
	const { content } = pageData;
	const { title, description, points, desktop_image, mobile_image } = content;

	return (
		<NetworkOfRepresentativesTemplateStyle className={`${points?.length > 0 ? 'has-points' : ''}`}>
			<GlobalHeroSection
				title={title}
				description={description}
				showBtn={false}
				desktop_image={desktop_image}
				mobile_image={mobile_image}
			/>

			<PointsSection items={points} />

			<MapFilterSection data={representatives} />
		</NetworkOfRepresentativesTemplateStyle>
	);
};

export default NetworkOfRepresentativesTemplate;
